import React, { useState } from 'react';
import { useAuth } from './AuthContext';

export default function Login() {
  const { signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await signIn(email, password);
    } catch (err: any) {
      setError(err.message || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center justify-center gap-3 mb-8">
          <div style={{display:"flex",flexDirection:"column",alignItems:"center",textAlign:"center"}}><img src="/techstaccs-white-11.png" alt="TechStaccs" style={{width:"180px",marginBottom:"14px"}} /><span style={{display:"block",letterSpacing:"0.15em",fontSize:"1.4rem",fontWeight:"800",color:"white",marginBottom:"6px"}}>BREAKER TRADES</span><span style={{background:"#3fb950",color:"#000",fontSize:"0.65rem",fontWeight:"700",padding:"2px 8px",borderRadius:"4px",letterSpacing:"0.1em"}}>LIVE</span></div>
        </div>
        <div className="bg-gray-900 rounded-lg border border-gray-800 p-6">
          <h2 className="text-white font-semibold text-lg mb-6 text-center">Sign In</h2>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="text-xs text-gray-500 uppercase tracking-wide block mb-1">Email</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                className="w-full bg-gray-800 border border-gray-700 rounded px-3 py-2 text-white text-sm focus:outline-none focus:border-blue-500"
                placeholder="you@example.com"
                required
              />
            </div>
            <div>
              <label className="text-xs text-gray-500 uppercase tracking-wide block mb-1">Password</label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                className="w-full bg-gray-800 border border-gray-700 rounded px-3 py-2 text-white text-sm focus:outline-none focus:border-blue-500"
                placeholder="••••••••"
                required
              />
            </div>
            {error && <p className="text-red-400 text-xs">{error}</p>}
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-blue-800 text-white rounded py-2 text-sm font-medium transition-colors"
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>
        </div>
        <p className="text-center text-xs text-gray-600 mt-4">Private system — authorized access only</p>
      </div>
    </div>
  );
}